//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {
  mdiVideoOutline,
  mdiMessageText,
  mdiSeal,
  mdiChevronRight,
} from '@mdi/js'
import { computed, useSlots } from '@vue/composition-api'

export default {
  name: 'ActionCard',
  props: {
    title: {
      type: String,
      default: '',
      required: true,
    },
    subtitle: {
      type: String,
      default: '',
      required: true,
    },
    showArrow: {
      type: Boolean,
      default: false,
    },
    avatarColor: {
      type: String,
      default: 'transparent',
    },
    avatarGradient: {
      type: String,
      default: '',
    },
    iconColor: {
      type: String,
      default: '#ffffff',
    },
    iconContainerStyles: {
      type: String,
      default: '',
    },
    borderColor: {
      type: String,
      default: '#FF3232',
    },
    showBorder: {
      type: Boolean,
      default: false,
    },
    showBorderGray: {
      type: Boolean,
      default: false,
    },
    cancelled: {
      type: Boolean,
      default: false,
    },
  },
  setup() {
    const slots = useSlots()

    const hasIconContent = computed(() => !!slots.icon)

    return {
      hasIconContent,

      icons: {
        mdiVideoOutline,
        mdiMessageText,
        mdiSeal,
        mdiChevronRight,
      },
    }
  },
}
